import { IssueFieldEnum } from "@mcapps/shared/enums";
import { ISSUE_COLUMN_LABELS } from "../issueConstants";
import { taskOrIssueENUM } from "@mctypes/global.types";
import { IIssueBoardApi } from "@mcapps/shared";
import {
  ICapitalLetter,
  IOtherAttributeConfigApi,
  IOtherAttributeConfigItemProps,
} from "@mcapps/shared/schemas/otherAttributesSchema";
import React from "react";
import { FailedAlert, MCLoader } from "../../../../components";
import OtherAttributesConfig from "../../../../components/OtherAttributes/OtherAttributesConfig/OtherAttributesConfig";
import {
  usePostProjectByProjectIdIssueboardOtherAttributesConfigAddMutation,
  usePostProjectByProjectIdIssueboardOtherAttributesConfigUpdateMutation,
  usePostProjectByProjectIdIssueboardOtherAttributesConfigUpdateorderMutation,
} from "../../../../../openapi";
import { getIssueActionNameOption, getIssueRegisterNameOption } from "../issueUtils";
import SettingsCardWrapper from "./SettingsCardWrapper";

const FORMULA_BASE_ATTRIBUTES = [IssueFieldEnum.BUCKET, IssueFieldEnum.STATUS, IssueFieldEnum.TITLE].map((value) => ({
  value,
  label: ISSUE_COLUMN_LABELS[value],
}));

const IssueOtherAttributesConfig: React.FC<{ issueBoard: IIssueBoardApi; taskOrIssue: taskOrIssueENUM }> = ({
  issueBoard,
  taskOrIssue,
}) => {
  const [addOtherAttribute, { isLoading: addLoading, isError: addError }] =
    usePostProjectByProjectIdIssueboardOtherAttributesConfigAddMutation();
  const [editOtherAttribute, { isLoading: editLoading, isError: editError }] =
    usePostProjectByProjectIdIssueboardOtherAttributesConfigUpdateMutation();
  const [updateOtherAttributeOrder, { isLoading: updateOrderLoading, isError: updateOrderError }] =
    usePostProjectByProjectIdIssueboardOtherAttributesConfigUpdateorderMutation();

  const issueBoardOtherAttributesConfig: IOtherAttributeConfigApi =
    taskOrIssue === "TASK" ? issueBoard.otherAttributesTasksConfig : issueBoard.otherAttributesConfig;

  const title =
    taskOrIssue === "TASK"
      ? `Egne attributter for ${getIssueActionNameOption(issueBoard?.taskNameSetting, "plural").toLocaleLowerCase()}`
      : `Egne attributter for ${getIssueRegisterNameOption(
          issueBoard?.issueNameSetting,
          "plural",
        ).toLocaleLowerCase()}`;

  const onAdd = (otherAttributesConfigItemProps: IOtherAttributeConfigItemProps) => {
    addOtherAttribute({
      projectId: issueBoard.project,
      body: {
        issueBoardId: issueBoard._id,
        otherAttributesConfigItemProps: otherAttributesConfigItemProps as any,
        taskOrIssue: taskOrIssue, // Assuming this is for issues, change if needed
      },
    });
  };

  const onEdit = (
    otherAttributeConfigItemProps: IOtherAttributeConfigItemProps,
    otherAttributeConfigKey: ICapitalLetter,
  ) => {
    editOtherAttribute({
      projectId: issueBoard.project,
      body: {
        issueBoardId: issueBoard._id,
        otherAttributeConfigItemProps: otherAttributeConfigItemProps as any,
        otherAttributeConfigKey,
        taskOrIssue: taskOrIssue,
      },
    });
  };

  const onUpdateOrder = (idsInOrder: ICapitalLetter[]) => {
    updateOtherAttributeOrder({
      projectId: issueBoard.project,
      body: {
        issueBoardId: issueBoard._id,
        idsInOrder: idsInOrder,
        taskOrIssue: taskOrIssue,
      },
    });
  };

  const isLoading = addLoading || editLoading || updateOrderLoading;
  const isError = addError || editError || updateOrderError;
  return (
    <SettingsCardWrapper title={title}>
      {isError && <FailedAlert />}
      {isLoading && <MCLoader />}
      <OtherAttributesConfig
        otherAttributesConfig={issueBoardOtherAttributesConfig ?? {}}
        onAdd={onAdd}
        onEdit={onEdit}
        onUpdateOrder={onUpdateOrder}
        allowFormulas={taskOrIssue !== "TASK"}
        formulaBaseAttributes={FORMULA_BASE_ATTRIBUTES}
        enableDropdownOptionDescriptions
      />
    </SettingsCardWrapper>
  );
};

export default IssueOtherAttributesConfig;
